export default {
    oidc: {
        clientId: process.env.REACT_APP_OKTA_CLIENTID,
        issuer: process.env.REACT_APP_OKTA_ISSUER,
        redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URL,
        responseMode: "fragment",
        scopes: ["openid", "profile", "email"],
    },
};
